import { render, staticRenderFns } from "./addProjectBomFromCopy.vue?vue&type=template&id=46c43516&scoped=true&"
import script from "./addProjectBomFromCopy.vue?vue&type=script&lang=js&"
export * from "./addProjectBomFromCopy.vue?vue&type=script&lang=js&"
import style0 from "./addProjectBomFromCopy.vue?vue&type=style&index=0&id=46c43516&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c43516",
  null
  
)

export default component.exports